<script>
  import { emitter } from '@/main.js';
  import { isProxy, toRaw } from 'vue';
  import VueCookies from 'vue-cookies';
  import PriceFilterSlider from '@/components/PriceFilterSlider.vue';
  import { sanitizeObjectKey, handleize, augmentHistoryReplaceState } from '@/lib/vue-helpers.js';

  export default {
    name: 'CollectionFilters',
    components: {
      PriceFilterSlider
    },
    data() {
      return {
        facets: [],
        avoidList: [],
        narrowBy: [],
        totalResults: 0,
        showFilters: false,
        filterToggle: null,
        sectionSettingFiltersListButtons: '',
        priceFilter: '',
        priceFilterMin: '',
        priceFilterMax: '',
        sliderColor: '',
        borderColor: '',
        borderRadius: '',
        expandedFilters: new Set(),
        filterAccordion: {
          toggleText: false,
          toggleBtns: false,
          limitText: 8,
          limitBtns: 8,
          labelMore: '',
          labelLess: ''
        },
        accordionGroups: new Map(),
        originalFacetOrder: [],
        isDesktop: window.siteGlobals.device === 'desktop-size',
        filterToggleButtons: [],
        filterUnderlay: null,
        filterToggleHandler: null,
        filterUnderlayHandler: null,
        ratingFilterShowLevel: '4',
        ratingFilterCountText: ' & up'
      };
    },
    mounted() {
      augmentHistoryReplaceState();

      this.sliderColor = this.$el.parentElement?.dataset?.sliderColor;
      this.borderColor = this.$el.parentElement?.dataset?.borderColor;
      this.borderRadius = this.$el.parentElement?.dataset?.borderRadius;
      this.filterToggle = document.getElementById('filter-toggle');
      this.ratingFilterShowLevel = this.$el.parentElement?.dataset?.ratingFilterShowLevel;
      this.ratingFilterCountText = this.$el.parentElement?.dataset?.ratingFilterCountText;
      const cookieValue = VueCookies.get('showFilters');
      this.showFilters = cookieValue ? JSON.parse(cookieValue) : false;

      if (this.isDesktop) {
        const filterWrapper = document.querySelector('.collection__filters__wrapper');

        if (filterWrapper) {
          filterWrapper.setAttribute('data-default-hide', this.showFilters ? 'false' : 'true');
          this.updateFilterVisibility(this.showFilters, filterWrapper);
        }
      }

      this.sectionSettingFiltersListButtons = this.$el.parentElement?.dataset?.filtersListButtons;

      const parentElement = this.$el?.parentElement?.parentElement;
      if (parentElement) {
        this.filterAccordion.toggleText = parentElement.dataset?.filterAccordionText === 'true' || false;
        this.filterAccordion.toggleBtns = parentElement.dataset?.filterAccordionBtns === 'true' || false;
        this.filterAccordion.limitText = parentElement.dataset?.filterAccordionLimitText || '8';
        this.filterAccordion.limitBtns = parentElement.dataset?.filterAccordionLimitBtns || '8';
        this.filterAccordion.labelMore = parentElement.dataset?.filterAccordionLabelMore || 'Show more';
        this.filterAccordion.labelLess = parentElement.dataset?.filterAccordionLabelLess || 'Show less';
      }
      this.narrowBy = this.getCurrentFilters();

      window.addEventListener('replacestate', this.syncStateFromUrl);

      this.$nextTick(() => {
        this.closeAllAccordions();
      });

      this.fsUpdateHandler = e => {
        if (e.facets) {
          this.handleFacetUpdate(e.facets);
        }
        this.setPriceFilterValues();
        this.avoidList = e.avoidPrefixList;
        this.totalResults = e.totalResults;

        // prettier-ignore
        [...document.querySelectorAll('#productCounter')].forEach((counter) => {counter.innerHTML = '(' + this.totalResults + ')';});
        this.setFilterCount(this.narrowBy);
      };

      emitter.on('fs-update', this.fsUpdateHandler);

      this.filterToggleButtons = Array.from(document.querySelectorAll('[data-filters-toggle="filters"]'));
      this.filterUnderlay = document.querySelector('[data-filters-underlay]');

      if (this.filterToggleButtons.length > 0) {
        let self = this;

        this.filterToggleHandler = function () {
          self.updateShowFilters(!self.showFilters);
        };

        this.filterUnderlayHandler = function () {
          self.updateShowFilters(false);
        };

        this.filterToggleButtons.forEach(button => {
          button.addEventListener('click', this.filterToggleHandler);
        });

        if (this.filterUnderlay) {
          this.filterUnderlay.addEventListener('click', this.filterUnderlayHandler);
        }
      }

      window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('replacestate', this.syncStateFromUrl);

      emitter.off('fs-update', this.fsUpdateHandler);

      if (this.filterToggleButtons && this.filterToggleHandler) {
        this.filterToggleButtons.forEach(button => {
          button.removeEventListener('click', this.filterToggleHandler);
        });
      }

      if (this.filterUnderlay && this.filterUnderlayHandler) {
        this.filterUnderlay.removeEventListener('click', this.filterUnderlayHandler);
      }
    },
    methods: {
      sanitizeObjectKey,
      handleize,
      syncStateFromUrl() {
        this.narrowBy = this.getCurrentFilters();
        this.setFilterCount(this.narrowBy);
      },
      updateShowFilters(newValue) {
        this.showFilters = newValue;

        if (this.isDesktop) {
          VueCookies.set('showFilters', newValue, '7d');
        }

        if (this.isDesktop) {
          const filterWrapper = document.querySelector('.collection__filters__wrapper');

          if (filterWrapper) {
            filterWrapper.setAttribute('data-default-hide', newValue ? 'false' : 'true');

            this.updateFilterVisibility(newValue, filterWrapper);
          }
        }
      },
      updateFilterVisibility(show, filterWrapper = null) {
        const wrapper = filterWrapper || document.querySelector('.collection__filters__wrapper');

        if (wrapper) {
          wrapper.classList.toggle('vue-filters--visible', show);
          wrapper.classList.toggle('filters--default-visible', show);

          if (this.filterToggle) {
            this.filterToggle.classList.toggle('vue-filters--visible', show);
          }
        }
      },
      setFilterCount(count) {
        let filterCount = count?.length || 0;
        if (filterCount > 9) {
          filterCount = 9;
        }
        const counter = document.getElementById('active-filters-count');
        if (counter) {
          if (filterCount > 0) {
            counter.innerHTML = `&nbsp;(${count?.length})`;
          } else {
            counter.innerHTML = '';
          }
        }
      },
      clearFilters() {
        const newFilters = [];
        this.setUrlParam('filters', newFilters);

        const sliderTrack = document.getElementById('slider-track');
        if (sliderTrack) {
          sliderTrack.style.background = `linear-gradient(to right, #00000000 0% , ${this.sliderColor} 0%, ${this.sliderColor} 100%, #00000000 100%)`;
        }
        const minInputText = document.getElementById('minInput');
        const minInputSlider = document.getElementById('slider-1');
        const maxInputText = document.getElementById('maxInput');
        const maxInputSlider = document.getElementById('slider-2');
        if (minInputText) minInputText.value = this.priceFilterMin;
        if (minInputSlider) minInputSlider.value = this.priceFilterMin;
        if (maxInputText) maxInputText.value = this.priceFilterMax;
        if (maxInputSlider) maxInputSlider.value = this.priceFilterMax;

        this.narrowBy = this.getCurrentFilters();
        this.setFilterCount(this.narrowBy);

        emitter.emit('filters-cleared');
        this.sendNarrowUpdate(newFilters);

        this.scrollToView();
      },
      scrollToView() {
        const scrollDiv = document.getElementById('collection-start')?.offsetTop || 0;
        const selectors = ['.collection__text-content', '.collection__nav--fs'];
        const offset = selectors.reduce((totalHeight, selector) => {
          const element = document.querySelector(selector);
          return totalHeight + (element ? element.offsetHeight : 0);
        }, 40);
        window.scrollTo({ top: scrollDiv - offset, behavior: 'smooth' });
      },
      sendNarrowUpdate(narrow) {
        emitter.emit('fs-update-filter', narrow);
      },
      getUrlParam(param) {
        const url = new URL(window.location.href);
        return url.searchParams.get(param);
      },
      getCurrentFilters() {
        let filters = this.getUrlParam('filters');
        if (filters) {
          return JSON.parse(decodeURIComponent(filters));
        }
        return [];
      },
      handleFilterInteraction(event, filter, value, selected) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();

        this.updateNarrow(filter, value, selected);
      },
      updateNarrow(filter, value, selected) {
        this.isUpdatingFilter = true;
        const currentFilters = this.getCurrentFilters();

        const newFilters = selected ? currentFilters.filter(item => !(item[0] === filter && item[1] === value)) : [...currentFilters, [filter, value]];

        this.setUrlParam('filters', newFilters);

        this.narrowBy = this.getCurrentFilters();
        this.setFilterCount(this.narrowBy);
        this.sendNarrowUpdate(this.narrowBy);
      },
      formatRatingLabel(facet, isButtonFormat = false) {
        return this.getStarLabel(facet, isButtonFormat);
      },
      getStarIconsHtml(facet) {
        const ratingValue = parseInt(facet[0]);
        if (isNaN(ratingValue)) {
          return '';
        }

        const starPath = 'M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z';
        let html = '';

        for (let i = 0; i < 5; i++) {
          const isFilled = i < ratingValue;

          if (isFilled) {
            html += `<svg aria-hidden="true" viewBox="0 0 18 18" class="filter-star filter-star--filled" width="15" height="15" style="display: flex; margin-inline-end: 3.5px;"><path d="${starPath}" stroke="rgba(0,0,0,1)" fill="var(--primary)"></path></svg>`;
          } else {
            html += `<svg aria-hidden="true" viewBox="0 0 18 18" class="filter-star filter-star--empty" width="15" height="15" style="display: flex; margin-inline-end: 3.5px;"><path d="${starPath}" stroke="rgba(0,0,0,1)" fill="transparent"></path></svg>`;
          }
        }
        return html;
      },
      getStarLabel(facet, isButtonFormat = false) {
        const ratingValue = parseInt(facet[0]);
        const count = facet[1];
        if (isNaN(ratingValue)) {
          return isButtonFormat ? facet[0] : ` ${facet[0]} (${count})`;
        }
        const label = ratingValue === 1 ? '1 Star' : `${ratingValue} Stars`;
        if (ratingValue < 5) {
          return isButtonFormat ? ` ${label}${this.ratingFilterCountText}` : ` ${this.ratingFilterCountText} (${count})`;
        } else {
          return isButtonFormat ? ` ${label}` : ` (${count})`;
        }
      },
      getStarAriaLabel(facet) {
        const ratingValue = parseInt(facet[0]);
        const count = facet[1];
        if (isNaN(ratingValue)) {
          return `Filter by ${facet[0]}, ${count} products`;
        }

        const starText = ratingValue === 1 ? '1 star' : `${ratingValue} stars`;
        const ratingText = ratingValue < 5 ? `${starText} and up` : starText;
        return `Filter by ${ratingText} rating, ${count} products`;
      },
      setUrlParam(paramName, paramValue) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set(paramName, JSON.stringify(paramValue));
          window.history.replaceState(null, null, url);
        } catch (error) {
          console.error('CollectionFilters: Failed to update URL:', error);
        }
      },
      isChecked(filter, value) {
        return this.narrowBy?.some(narrow => narrow[0] === filter && narrow[1] === value) || false;
      },
      cleanFacetName(facet, facetIsButton, filterKey = null) {
        if (filterKey === 'Isp-review-stars') {
          return this.formatRatingLabel(facet, facetIsButton);
        }
        let fName = facet[0] || '';
        const fCount = facet[1];
        const prefix = this.avoidList?.find(avoid => fName.startsWith(avoid));
        if (prefix) {
          fName = fName.replace(prefix, '');
        }
        return facetIsButton ? fName : `${fName} (${fCount})`;
      },
      handleFacetUpdate(data) {
        if (data) {
          let newFacets = data;
          if (isProxy(data)) {
            newFacets = toRaw(data);
          }

          if (this.originalFacetOrder.length === 0) {
            this.originalFacetOrder = newFacets.map(facet => facet[2]);
            this.facets = newFacets;
            return;
          }

          const sortedFacets = [];

          this.originalFacetOrder.forEach(originalName => {
            const matchingFacet = newFacets.find(facet => facet[2] === originalName);
            if (matchingFacet) {
              sortedFacets.push(matchingFacet);
            }
          });

          newFacets.forEach(facet => {
            if (!this.originalFacetOrder.includes(facet[2])) {
              sortedFacets.push(facet);
              this.originalFacetOrder.push(facet[2]);
            }
          });

          this.facets = sortedFacets;
        }
      },
      setPriceFilterValues() {
        for (let i = 0; i < this.facets.length; i++) {
          const facet = this.facets[i];
          if (facet[0] === 'Price') {
            this.priceFilter = facet[1][0];
          }
          if (facet[0] === 'Price_min') {
            this.priceFilterMin = facet[1][0];
          }
          if (facet[0] === 'Price_max') {
            this.priceFilterMax = facet[1][0];
          }
        }
      },
      toggleShowMore(filterIndex) {
        if (this.expandedFilters.has(filterIndex)) {
          this.expandedFilters.delete(filterIndex);
        } else {
          this.expandedFilters.add(filterIndex);
        }
      },
      toggleAccordion(event, filterName) {
        if (!this.isValidAccordionClick(event)) return;

        this.preventThemeInterference(event);
        const sanitizedKey = sanitizeObjectKey(filterName);
        this.accordionGroups.set(sanitizedKey, !this.accordionGroups.get(sanitizedKey) || false);
      },
      closeAllAccordions() {
        this.accordionGroups.clear();
      },
      handleListClick(event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'LABEL' && event.target.tagName !== 'BUTTON') {
          event.preventDefault();
        }
      },
      handleListMouseDown(event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
      },
      handleGroupClick(event) {
        if (event.target.closest('.filter__show-more-button')) return;
        if (event.target.closest('.filter__button') !== null) {
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      },

      handleResize() {
        window.setClientWidthClass();
        this.isDesktop = window.siteGlobals.device === 'desktop-size';
      },
      preventThemeInterference(event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();
      },

      isValidAccordionClick(event) {
        return event.target.classList.contains('vue-accordion-trigger') || event.currentTarget.classList.contains('vue-accordion-trigger');
      },

      findFilterIndexByName(filterName) {
        if (!this.facets) return -1;

        const strategies = [name => name.toLowerCase(), name => name.replace(/-/g, ' ').toLowerCase(), name => name.replace(/_/g, ' ').toLowerCase(), name => name.toLowerCase().replace(/\s+/g, '-')];

        for (const strategy of strategies) {
          const processedName = strategy(filterName);
          const index = this.facets.findIndex(facet => strategy(facet[2]) === processedName);
          if (index !== -1) return index;
        }

        return -1;
      }
    },
    computed: {
      activeFacetsCount() {
        const counts = {};
        if (this.narrowBy && this.facets) {
          for (const narrow of this.narrowBy) {
            const matchingFacet = this.facets.find(facet => facet[0] === narrow[0]);
            const facetTitle = matchingFacet ? matchingFacet[2] : narrow[0];
            if (!counts[facetTitle]) {
              counts[facetTitle] = 0;
            }
            counts[facetTitle]++;
          }
        }
        return counts;
      },
      currentActiveFacetCount() {
        return facetTitle => this.activeFacetsCount[facetTitle] || 0;
      },
      shouldDisplayFilterAsButton() {
        return filter => {
          if (!filter || typeof filter !== 'string') {
            return false;
          }

          return new RegExp(`\\b${filter.toLowerCase()}\\b`, 'i').test(this.sectionSettingFiltersListButtons.toLowerCase());
        };
      },
      isExpanded() {
        return filterIndex => this.expandedFilters.has(filterIndex);
      },
      getFilterConfig() {
        return filter => {
          if (!filter || !Array.isArray(filter) || filter.length < 3) {
            return {
              isButtonType: false,
              shouldLimit: false,
              limit: 0,
              itemCount: 0
            };
          }

          const isButtonType = this.shouldDisplayFilterAsButton(filter[2]);
          return {
            isButtonType,
            shouldLimit: isButtonType ? this.filterAccordion.toggleBtns : this.filterAccordion.toggleText,
            limit: Number(isButtonType ? this.filterAccordion.limitBtns : this.filterAccordion.limitText),
            itemCount: filter[1]?.length || 0
          };
        };
      },
      shouldShowMoreButton() {
        return filter => {
          const config = this.getFilterConfig(filter);
          return config.shouldLimit && config.itemCount > config.limit;
        };
      },
      getVisibleFacets() {
        return (filter, index) => {
          const config = this.getFilterConfig(filter);
          const isExpanded = this.isExpanded(index);
          if (!filter || !Array.isArray(filter) || !filter[1] || !Array.isArray(filter[1])) {
            return [];
          }
          let facetValues = filter[1];
          if (filter[0] === 'Isp-review-stars') {
            facetValues = [...filter[1]].reverse();
            const minRating = parseInt(this.ratingFilterShowLevel);
            facetValues = facetValues.filter(facet => {
              const ratingValue = parseInt(facet[0]);
              return !isNaN(ratingValue) && ratingValue >= minRating;
            });
          }
          return !config.shouldLimit || isExpanded ? facetValues : facetValues.slice(0, config.limit);
        };
      }
    },
    watch: {
      narrowBy: {
        handler(newNarrowBy) {
          this.setFilterCount(newNarrowBy);
        },
        immediate: false,
        deep: true
      }
    }
  };
</script>

<template>
  <div class="filter-controls">
    <p class="count" v-html="totalResults + ' Results'"></p>
    <p @click.prevent="clearFilters" class="clear" v-if="narrowBy && narrowBy.length > 0">Clear Filters</p>
  </div>
  <div v-if="totalResults > 0">
    <div v-for="(filter, index) in facets" :key="'facet-' + sanitizeObjectKey(filter[2])">
      <div :class="['sidebar__filter__group', accordionGroups.get(sanitizeObjectKey(filter[2])) === true ? '' : 'accordion-is-closed']" v-if="filter[2] === 'Price'" @click.capture="handleGroupClick($event)">
        <button class="sidebar__heading vue-accordion-trigger" @click.prevent.stop="toggleAccordion($event, filter[2])" :aria-expanded="accordionGroups.get(sanitizeObjectKey(filter[2])) === true" :aria-controls="`filter-group-${handleize(filter[2])}`">
          <span :id="handleize(String(index))" v-html="filter[2]"></span>
          <span v-if="currentActiveFacetCount(filter[2]) > 0" :id="'filter-count-' + handleize(String(index))">
            <span class="visually-hidden">
              , {{ currentActiveFacetCount(filter[2]) }} filter{{ currentActiveFacetCount(filter[2]) > 1 ? 's' : '' }}
              applied
            </span>
            <b aria-hidden="true"> &nbsp;({{ currentActiveFacetCount(filter[2]) }}) </b>
          </span>
          <span class="sidebar__heading-chevron">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-medium-right" viewBox="0 0 9 15">
              <path fill-rule="evenodd" d="M6.875 7.066.87 1.06 1.93 0l6.006 6.005L7.94 6 9 7.06l-.004.006.005.005-1.06 1.06-.006-.004-6.005 6.005-1.061-1.06 6.005-6.006z" />
            </svg>
          </span>
        </button>
        <ul :class="`sidebar__navigation__list ${shouldDisplayFilterAsButton(filter[2]) ? 'filter__button-type-button-container' : ''}`" style="margin-top: 0px; padding-top: 0px" @click.stop.prevent="handleListClick($event)" @mousedown.stop="handleListMouseDown($event)">
          <li class="filter__button">
            <PriceFilterSlider :priceFilterMin="priceFilterMin" :priceFilterMax="priceFilterMax" :priceFilter="priceFilter" :sliderColor="sliderColor" :borderColor="borderColor" :borderRadius="borderRadius" />
          </li>
        </ul>
      </div>

      <div :class="['sidebar__filter__group', accordionGroups.get(sanitizeObjectKey(filter[2])) === true ? '' : 'accordion-is-closed']" v-if="!filter[2].startsWith('Price')" @click.capture="handleGroupClick($event)">
        <button class="sidebar__heading vue-accordion-trigger" @click.prevent.stop="toggleAccordion($event, filter[2])" :aria-expanded="accordionGroups.get(sanitizeObjectKey(filter[2])) === true" :aria-controls="`filter-group-${handleize(filter[2])}`">
          <span :id="handleize(String(index))" v-html="filter[2]"></span>
          <span v-if="currentActiveFacetCount(filter[2]) > 0" :id="'filter-count-' + handleize(String(index))">
            <span class="visually-hidden">
              , {{ currentActiveFacetCount(filter[2]) }} filter{{ currentActiveFacetCount(filter[2]) > 1 ? 's' : '' }}
              applied
            </span>
            <b aria-hidden="true"> &nbsp;({{ currentActiveFacetCount(filter[2]) }}) </b>
          </span>
          <span class="sidebar__heading-chevron">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-medium-right" viewBox="0 0 9 15">
              <path fill-rule="evenodd" d="M6.875 7.066.87 1.06 1.93 0l6.006 6.005L7.94 6 9 7.06l-.004.006.005.005-1.06 1.06-.006-.004-6.005 6.005-1.061-1.06 6.005-6.006z" />
            </svg>
          </span>
        </button>
        <ul :class="`sidebar__navigation__list ${shouldDisplayFilterAsButton(filter[2]) ? 'filter__button-type-button-container' : ''}`" :id="`filter-group-${handleize(filter[2])}`" @click.stop.prevent="handleListClick($event)" @mousedown.stop="handleListMouseDown($event)">
          <li v-for="(facet, facetIndex) in getVisibleFacets(filter, index)" :key="'facet-' + facetIndex" class="filter__button" @click.stop="handleFilterInteraction($event, filter[0], facet[0], isChecked(filter[0], facet[0]))">
            <input type="checkbox" :name="handleize(facet[0])" :value="facet[0]" :id="handleize(facet[0]) + '-' + facetIndex" :checked="isChecked(filter[0], facet[0])" @click.stop.prevent="handleFilterInteraction($event, filter[0], facet[0], isChecked(filter[0], facet[0]))" @change.stop.prevent="handleFilterInteraction($event, filter[0], facet[0], isChecked(filter[0], facet[0]))" />
            <label :for="handleize(facet[0]) + '-' + facetIndex" :class="shouldDisplayFilterAsButton(filter[2]) && 'filter__button-type-button'" @click.stop.prevent="handleFilterInteraction($event, filter[0], facet[0], isChecked(filter[0], facet[0]))">
              <span :class="`${!shouldDisplayFilterAsButton(filter[2]) ? 'text-center' : ''}`">
                <template v-if="filter[0] === 'Isp-review-stars'">
                  <span class="star-rating star-icons" role="img" :aria-label="getStarAriaLabel(facet)" v-html="getStarIconsHtml(facet)"> </span>
                  <span class="star-label" aria-hidden="true">{{ getStarLabel(facet, shouldDisplayFilterAsButton(filter[2])) }}</span>
                </template>
                <template v-else>
                  {{ cleanFacetName(facet, shouldDisplayFilterAsButton(filter[2]), filter[0]) }}
                </template>
              </span>
              <svg v-if="!shouldDisplayFilterAsButton(filter[2])" aria-hidden="true" focusable="false" role="presentation" class="icon icon-box" viewBox="0 0 20 20">
                <g fill="none" fill-rule="evenodd">
                  <path class="checkbox-border" stroke="#000" d="M.5.5h19v19H.5z"></path>
                  <path class="checkbox-core" fill="#000" d="M5 5h10v10H5z"></path>
                </g>
              </svg>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-reset" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M20 10a9.73 9.73 0 0 1-.794 3.88 10.088 10.088 0 0 1-2.136 3.19 10.089 10.089 0 0 1-3.19 2.136A9.73 9.73 0 0 1 10 20a9.93 9.93 0 0 1-4.258-.944 9.776 9.776 0 0 1-3.437-2.663.465.465 0 0 1-.085-.293.384.384 0 0 1 .11-.267l1.785-1.797a.468.468 0 0 1 .325-.117c.139.018.239.07.3.157a6.535 6.535 0 0 0 2.33 1.914c.92.451 1.897.677 2.93.677a6.49 6.49 0 0 0 2.585-.528 6.717 6.717 0 0 0 2.129-1.425 6.717 6.717 0 0 0 1.425-2.13c.352-.82.528-1.681.528-2.584s-.176-1.764-.528-2.585a6.717 6.717 0 0 0-1.425-2.129 6.717 6.717 0 0 0-2.13-1.425A6.494 6.494 0 0 0 10 3.333c-.85 0-1.667.154-2.448.463A6.469 6.469 0 0 0 5.47 5.117l1.784 1.797c.269.26.33.56.182.899-.148.347-.404.52-.768.52H.833a.8.8 0 0 1-.586-.247A.8.8 0 0 1 0 7.5V1.667c0-.365.174-.621.52-.769.34-.147.639-.086.9.183l1.692 1.68A10.107 10.107 0 0 1 6.296.722 9.809 9.809 0 0 1 10 0a9.73 9.73 0 0 1 3.88.794 10.088 10.088 0 0 1 3.19 2.136 10.088 10.088 0 0 1 2.136 3.19A9.73 9.73 0 0 1 20 10z"></path>
              </svg>
            </label>
          </li>
          <li v-if="shouldShowMoreButton(filter)" class="filter__button filter__show-more">
            <button
              class="filter__show-more-button gt-p__small"
              :aria-expanded="isExpanded(index)"
              :aria-controls="`filter-group-${handleize(filter[2])}`"
              @click="toggleShowMore(index)"
            >
              {{ isExpanded(index) ? filterAccordion.labelLess : filterAccordion.labelMore }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  #fs-collection-filters {
    .filter-controls {
      display: flex;
      padding-bottom: 20px;
      padding-top: 10px;
      padding-right: 10px;
      .count {
        color: var(--text);
      }
      .clear {
        color: var(--text);
        margin-left: auto;
        border-bottom: 1px solid #fff;
        text-transform: uppercase;
        font-size: 12px;
        cursor: pointer;
        text-decoration: underline;
      }
    }
    .sidebar__filter__group {
      border-bottom: 1px solid var(--border);
      padding-bottom: 20px;
      position: relative;

      .sidebar__heading-chevron {
        transform: rotate(90deg);
      }

      .sidebar__navigation__list {
        position: relative;
        z-index: 1;
        pointer-events: auto;
      }
    }
    .accordion-is-closed {
      .sidebar__heading-chevron {
        transform: rotate(0deg);
      }
      ul {
        display: none;
      }
    }

    .vue-accordion-trigger {
      pointer-events: auto;
      position: relative;
      z-index: 2;
      isolation: isolate;
    }

    .filter__button {
      pointer-events: auto;
      isolation: isolate;

      input[type='checkbox'] {
        pointer-events: auto;
        position: relative;
        z-index: 1;
      }

      label {
        pointer-events: auto;
        position: relative;
        z-index: 1;
        user-select: none;
      }
    }

    .filter__button-type-button-container {
      .filter__button {
        isolation: isolate;

        position: relative;

        input[type='checkbox'] {
          opacity: 0;
          position: absolute;
          pointer-events: auto;
          z-index: 10;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          margin: 0;
          padding: 0;
          max-width: 100%;
          max-height: 100%;
        }

        label.filter__button-type-button {
          pointer-events: auto;
          position: relative;
          z-index: 1;
          display: flex !important;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }
      }
    }
  }
  .filter__show-more {
    margin-top: 8px;
    width: 100%;
    grid-column: 1 / -1;
    &-button {
      color: inherit;
      padding: 4px 0;
      cursor: pointer;
      text-decoration: underline;
      &:hover {
        color: var(--primary);
      }
    }
  }
  .sidebar__navigation__list {
    position: relative;
    &.is-expanded {
      max-height: none;
    }
  }
  .sidebar__filter__group {
    .star-rating {
      display: inline-block;
      font-size: 16px;
      line-height: 1;
    }

    .star-icons {
      display: inline-flex;
      align-items: center;

      .filter-star {
        flex-shrink: 0;
      }
    }
  }
</style>
